<div mat-dialog-title>
  <mat-icon class="dialog-icon mat-icon" [class]="fontIcon">{{ fontIcon }}</mat-icon>
  <span class="title-container">{{ data.title }}</span>
</div>
<div mat-dialog-content>
  {{ data.message }}
</div>
<br />
@if (data.additionalInfo) {
  @for (info of data.additionalInfo; track info) {
    <div mat-dialog-content class="mat-caption">
      <b>{{ info }}</b>
    </div>
  }
}

<div mat-dialog-actions align="end">
  @if (data.buttons) {
    @for (button of data.buttons; track button.label) {
      <button mat-button (click)="onButtonClick(button)" [id]="getButtonId(button.label)">
        {{ button.label }}
      </button>
    }
  }
</div>
